(function () {
  var drawer = document.querySelector('.sq-mobile-menu');
  var backdrop = document.querySelector('.sq-mobile-menu-backdrop');
  if (!drawer || !backdrop) return;

  var closeBtn = drawer.querySelector('[data-sq-mobile-menu-close]');
  var triggerBtn = null; // Stores the button that opened the drawer

  function getFocusableElements() {
    return drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  function open(trigger) {
    triggerBtn = trigger || null;
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    document.body.classList.add('sq-mobile-menu-locked');

    // Move focus to close button after transition
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.classList.remove('sq-mobile-menu-locked');

    // Return focus to the trigger that opened the drawer
    if (triggerBtn) {
      triggerBtn.focus();
      triggerBtn = null;
    }
  }

  // Event delegation: open triggers
  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-sq-mobile-menu-open]');
    if (openTrigger) {
      e.preventDefault();
      open(openTrigger);
      return;
    }

    // Close on backdrop click
    if (e.target === backdrop) {
      close();
      return;
    }

    // Close button
    var closeTrigger = e.target.closest('[data-sq-mobile-menu-close]');
    if (closeTrigger && drawer.contains(closeTrigger)) {
      e.preventDefault();
      close();
    }
  });

  // Esc key closes drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      close();
    }
  });

  // Focus trap
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;

    var focusable = getFocusableElements();
    if (focusable.length === 0) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      // Shift+Tab on first element wraps to last
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      // Tab on last element wraps to first
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();
